import React from 'react';
import AppInstallsContainer from './AppInstallsContainer';
import ConversionsContainer from './ConversionsContainer';
import EventResponsesContainer from './EventResponsesContainer';
import LinkClicksContainer from './LinkClicksContainer';
import LeadGenerationContainer from './LeadGenerationContainer';
import ReachContainer, { BrandAwarnessContainer } from './ReachContainer';
import PageLikesContainer from './PageLikesContainer';
import VideoViewsContainer from './VideoViewsContainer';
import GenericSocialContainer from './GenericSocialContainer';

exports.objectiveMap = {
    APP_INSTALLS: AppInstallsContainer,
    BRAND_AWARENESS: BrandAwarnessContainer,
    CONVERSIONS: ConversionsContainer,
    EVENT_RESPONSES: EventResponsesContainer,
    LEAD_GENERATION: LeadGenerationContainer,
    LINK_CLICKS: LinkClicksContainer,
    OUTCOME_SALES: props => (<GenericSocialContainer objective="OUTCOME_SALES" {...props} />),
    OUTCOME_LEADS: props => (<GenericSocialContainer objective="OUTCOME_LEADS" {...props} />),
    LOCAL_AWARENESS: props => (<GenericSocialContainer objective="LOCAL_AWARENESS" {...props} />),
    MESSAGES: props => (<GenericSocialContainer objective="MESSAGES" {...props} />),
    OFFER_CLAIMS: props => (<GenericSocialContainer objective="OFFER_CLAIMS" {...props} />),
    PAGE_LIKES: PageLikesContainer,
    POST_ENGAGEMENT: props => (<GenericSocialContainer objective="POST_ENGAGEMENT" {...props} />),
    PRODUCT_CATALOG_SALES: props => (<GenericSocialContainer objective="PRODUCT_CATALOG_SALES" {...props} />),
    REACH: ReachContainer,
    STORE_VISITS: props => (<GenericSocialContainer objective="STORE_VISITS" {...props} />),
    VIDEO_VIEWS: VideoViewsContainer,
};



// WEBPACK FOOTER //
// ./src/containers/dashboards/social/index.js